import React, { useEffect, useState } from 'react';
import { supabase } from '../../supabaseClient';
import { Container, Typography, List, ListItem, ListItemText } from '@mui/material';

const SessionLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchLogs = async () => {
      setLoading(true);
      const { data, error } = await supabase.from('session_logs').select('*');
      if (error) {
        setError(error.message);
      } else {
        setLogs(data);
      }
      setLoading(false);
    };
    fetchLogs();
  }, []);

  if (loading) {
    return (
      <Container>
        <Typography variant="h4">Loading...</Typography>
      </Container>
    );
  }

  return (
    <Container>
      <Typography variant="h4">Session Logs</Typography>
      {error && <Typography color="error" mt={2}>{error}</Typography>}
      <List>
        {logs.map(log => (
          <ListItem key={log.id}>
            <ListItemText primary={`Logged in at ${new Date(log.timestamp).toLocaleString()}`} />
          </ListItem>
        ))}
      </List>
    </Container>
  );
};

export default SessionLogs;